import t from "react-hot-toast";

const template = {
  error: { 
    background: "#f7c5c5",
    color: "#FF0303"
  },
  info: {
    background: "#bbcaf1",
    color: "#0A2C6C"
  },
  success: { 
    background: "#d8f7d3",
    color: "#25D308"
  },
  warning: {
    background: "#f9f6a7",
    color: "black"
  }
};

const useToast = () => {
  const toast = (message, style, extras = {}) => { 
    t(message, {
      style: {
        ...(typeof style === "string" ? template[style] :  style),
        ...extras?.style
      },
      ...extras
    })
  };

  return {
    toast
  };
};

export default useToast;
